import PropTypes from 'prop-types';
import { StyledTextarea, TextareaWrapper } from './textarea.style';
import TextField from '@mui/material/TextField';

const TextareaComponent = ({ rows = 5, mui, ...props }) => {
    return (
        <TextareaWrapper>
            {
                mui ? (
                    <TextField {...props} multiline rows={rows} variant="filled" style={{ width: '100%' }} />
                ) : (
                    <StyledTextarea {...props} rows={rows} />
                )
            }
        </TextareaWrapper>
    );
};

TextareaComponent.propTypes = {
    rows: PropTypes.number,
};

export default TextareaComponent;
